var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTrendUpFilled = function SvgTrendUpFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M4 3a1 1 0 0 0-2 0v16.432c0 .252 0 .498.017.706.019.229.063.499.201.77a2 2 0 0 0 .874.874c.271.138.541.182.77.201.208.017.454.017.706.017H21a1 1 0 1 0 0-2H4.6c-.297 0-.459 0-.575-.01l-.014-.002v-.013A8 8 0 0 1 4 19.4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M20.73 8.684a1 1 0 1 0-1.46-1.368l-3.815 4.072-3.123-1.621-.021-.011-.016-.009c-.134-.071-.412-.22-.721-.248a1.5 1.5 0 0 0-.759.13c-.282.13-.495.362-.597.474l-.009.009-.02.022-3.919 4.182a1 1 0 1 0 1.46 1.368l3.815-4.072 3.123 1.621.037.02c.134.071.412.22.721.248a1.5 1.5 0 0 0 .759-.13c.282-.13.495-.362.597-.474l.029-.03z"
  })));
};
export default SvgTrendUpFilled;